// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toast[data-v-b15e6969]{position:fixed;bottom:20px;left:50%;transform:translateX(-50%);z-index:250;background-color:rgba(0,0,0,.6);color:#fff;padding:16px 24px;border-radius:8px;display:flex;align-items:center;justify-content:space-between;min-width:300px;max-width:80%;font-size:12px;box-shadow:0 4px 8px rgba(0,0,0,.3)}.toast-close-button[data-v-b15e6969]{background:none;border:none;color:#fff;font-size:16px;cursor:pointer}", ""]);
// Exports
module.exports = exports;
